import { useNavigate, type NavigateFunction } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import { Suspense, createElement, useEffect } from "react";
import routes from "./config";

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();
  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(window.REACT_APP_NAVIGATE);
  });
  // Páginas carregadas sob demanda: enquanto o pedaço chega, um aviso discreto no padrão do portal.
  return createElement(
    Suspense,
    {
      fallback: createElement(
        "div",
        { className: "flex min-h-[60vh] items-center justify-center gap-2 text-sm text-foreground-600", role: "status" },
        createElement("i", { className: "ri-loader-4-line animate-spin text-xl text-primary-600", "aria-hidden": true }),
        "Carregando…",
      ),
    },
    element,
  );
}
